<template>
  <span
    v-if="!photoUrl"
    class="white--text headline"
  >
    {{ !name ? '?' : name.charAt() }}
  </span>
  <img
    v-else
    :src="photoUrl"
  >
</template>

<script>
export default {
  props: {
    photoUrl: { type: String, require: true },
    name: { type: String, require: false, default: '?' },
  },
};
</script>
